module.exports = __webpack_public_path__ + "img/submit-btn.0123938.png";